import React from "react";
import axios from "axios";
import { Row, Container, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { t } from "../../../localization/localization";

class DashboardSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      year: "ALL",
    };
  }

  componentDidMount() {
    this.getDashboard();
  }

  getDashboard = () => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${this.props.crisId}/bibliometrics`
      )
      .then((res) => {
        this.setState({ data: res.data });
      });
  };

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    if (!this.state.data) {
      return null;
    }
    return (
      <>
        <p style={{ fontStyle: "italic" }}>
          {t(locale, "/rs/profile/dashboardSummary/info")}
        </p>
        <Container fluid>
          <Row className="wall">
            <Col>
              <img
                src={`/stats/${window._env_.ENV_NAME}/logo.png`}
                style={{ height: 48, marginBottom: 8 }}
              />
              <Row className="text-center">
                <Col xs="6" md="4" className="circle-wrapper">
                  <div className="circle">
                    <h1 style={{ color: "#001F54" }}>
                      {this.state.data.scholarlyOutput}
                    </h1>
                    <h6 style={{ color: "#275DAD" }}>
                      {t(
                        locale,
                        "/rs/profile/dashboardSummary/scholarlyOutput"
                      )}
                    </h6>
                  </div>
                </Col>
                <Col xs="6" md="4" className="circle-wrapper">
                  <div className="circle">
                    <h1 style={{ color: "#001F54" }}>
                      {this.state.data.citationCount}
                    </h1>
                    <h6 style={{ color: "#275DAD" }}>
                      {t(locale, "/rs/profile/dashboardSummary/citationCount")}
                    </h6>
                  </div>
                </Col>
                <Col xs="6" md="4" className="circle-wrapper">
                  <div className="circle">
                    <h1 style={{ color: "#001F54" }}>
                      {this.state.data.supervisedPhDTheses +
                        this.state.data.supervisedMScTheses}
                    </h1>
                    <h6 style={{ color: "#275DAD" }}>
                      {t(
                        locale,
                        "/rs/profile/dashboardSummary/supervisedTheses"
                      )}
                    </h6>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default withRouter(DashboardSummary);
